<template>
  <transition name="app-alert-fade">
    <div v-if="visible" class="app-alert" :class="alertClasses" :style="alertStyle" role="alert">
      <div class="app-alert__content">
        <span v-if="icon" class="material-icons app-alert__icon">{{ icon }}</span>
        <slot />
      </div>
      <button v-if="dismissible" class="app-alert__close" @click="dismiss" aria-label="Close">&times;</button>
    </div>
  </transition>
</template>

<script>
import { VARIANT_COLORS } from './variants.js'

export default {
  name: 'AppAlert',
  props: {
    show: { type: Boolean, default: true },
    variant: { type: String, default: 'info' },
    dismissible: { type: Boolean, default: false },
    fade: { type: Boolean, default: false },
    icon: { type: String, default: '' }
  },
  emits: ['dismissed'],
  data() {
    return { visible: this.show }
  },
  computed: {
    alertClasses() {
      return { 'app-alert--dismissible': this.dismissible }
    },
    alertStyle() {
      const c = VARIANT_COLORS[this.variant] || VARIANT_COLORS.info
      return {
        backgroundColor: c.light,
        color: c.border,
        borderColor: c.border
      }
    }
  },
  watch: {
    show(val) { this.visible = val }
  },
  methods: {
    dismiss() {
      this.visible = false
      this.$emit('dismissed')
    }
  }
}
</script>

<style scoped>
.app-alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid;
  border-radius: 0.25rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.app-alert__content { display: flex; align-items: flex-start; gap: 8px; }
.app-alert__icon   { font-size: 20px; flex-shrink: 0; }

.app-alert__close {
  background: none;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: inherit;
  opacity: 0.5;
  cursor: pointer;
  padding: 0 4px;
}
.app-alert__close:hover { opacity: 0.75; }

.app-alert-fade-enter-active,
.app-alert-fade-leave-active { transition: opacity 0.3s; }
.app-alert-fade-enter,
.app-alert-fade-leave-to { opacity: 0; }
</style>
